// src/pages/PrivacyPolicy.jsx
import React from 'react'
import { Card, Col, Row, Typography } from 'antd'
import { Link } from 'react-router-dom'
import {
	GeneralContentWrapper,
	GeneralTitle
} from '../../components/Shared/GeneralComponents'

const { Title, Paragraph } = Typography

const entities = [
	{
		name: 'Webackit Solutions S.R.L.',
		region: 'EU clients',
		address: 'Str. Splaiul Independenței, nr.202B, București, Romania',
		fiscal: 'RO44553258',
		vat: '44601134',
		register: 'J40/11711/2021'
	},
	{
		name: 'Webackit LLC',
		region: 'US clients',
		address: '6847, 1021 E Lincolnway, Cheyenne, WY 82001, USA',
		fiscal: '612194135'
	}
]

const websites = [
	'wordpress-shortcode.com',
	'wordpress-page-builder.com',
	'wordpress-database.com',
	'wordpress-ecommerce-theme.com',
	'wordpress-pricing.com',
	'wordpress-free.com',
	'wordpress-admin.com',
	'wordpress-logs.com',
	'wordpress-onepage.com',
	'developer-wordpress.com',
	'wordpress-api.com',
	'wordpress-development-services.com',
	'wordpress-homepage.com',
	'wordpress-landing-page.com',
	'pqazml.com',
	'on-subscription.com'
]

const PrivacyPolicy = () => (
	<GeneralContentWrapper>
		<GeneralTitle text="Privacy Policy" />

		<Title level={3}>1. Responsible Entity & Contact</Title>
		{entities.map((e) => (
			<Paragraph key={e.name}>
				<strong>
					{e.name} ({e.region})
				</strong>
				<br />
				{e.address}
				<br />
				Fiscal Number: {e.fiscal}
				<br />
				{e.vat && (
					<>
						VAT Number: {e.vat}
						<br />
					</>
				)}
				{e.register && <>Commercial Register: {e.register}</>}
			</Paragraph>
		))}
		<Paragraph>
			Email: contact@on-subscription.com · Phone: +40 748 702 852
		</Paragraph>

		<Title level={3}>2. Our Platforms</Title>
		<Paragraph>
			We operate the following websites. To improve your experience, we
			may share data between these platforms when you interact on any of
			them:
		</Paragraph>
		<Row gutter={8}>
			{websites.map((site, i) => (
				<Col key={i} xs={12} sm={8} md={6}>
					<a
						href={`https://${site}`}
						target="_blank"
						rel="noreferrer"
					>
						{site}
					</a>
				</Col>
			))}
		</Row>

		<Card>
			<Title level={3}>3. Scope & Compliance</Title>
			<Paragraph>
				EU clients: personal data processed under GDPR. US clients: data
				rights handled per CCPA where applicable.
			</Paragraph>
		</Card>

		<Title level={3}>4. Data We Collect</Title>
		<Paragraph>
			• Account information (name, email, company)
			<br />
			• Billing details (invoicing address, payment tokens via Stripe)
			<br />
			• Usage data (pages visited, actions taken)
			<br />
			• Device & log data (IP address, browser type, timestamps)
			<br />• Cookies/local storage: temporary caching of user actions,
			preferences, query results for performance.
		</Paragraph>

		<Card>
			<Title level={3}>5. How We Use Data</Title>
			<Paragraph>
				• Provide and maintain platform features
				<br />
				• Process payments and billing
				<br />
				• Improve performance via cached data
				<br />
				• Share usage data across our owned platforms to personalize
				your experience
				<br />
				• Communicate updates, billing notices, and support
				<br />• Analyze usage for product development
			</Paragraph>
		</Card>

		<Card>
			<Title level={3}>6. Cookies & Performance Data</Title>
			<Paragraph>
				We use cookies and local storage strictly to cache temporary
				data—such as form inputs, query results, UI state—to accelerate
				response times and minimize repeated API calls. These do not
				track you across external sites.
			</Paragraph>
		</Card>

		<Card>
			<Title level={3}>7. Third-Party Services</Title>
			<Paragraph>
				Payments: Stripe (https://stripe.com/legal).
				<br />
				Analytics (optional): Google Analytics
				(https://policies.google.com/privacy).
				<br />
				We do not sell personal data; we share only aggregated,
				anonymized usage metrics with trusted partners.
			</Paragraph>
		</Card>

		<Card>
			<Title level={3}>8. Data Retention & Your Rights</Title>
			<Paragraph>
				We retain account and billing data as required by law; usage
				logs and cached data for up to 1 year.
				<br />
				You may request data export, correction, or deletion at any time
				under GDPR/CCPA.
			</Paragraph>
		</Card>

		<Card>
			<Title level={3}>9. Security & Breach Notification</Title>
			<Paragraph>
				We implement industry-standard security measures. In case of a
				data breach, affected users will be notified promptly with
				recommended actions.
			</Paragraph>
		</Card>

		<Title level={3}>10. Automated Decision-Making</Title>
		<Paragraph>
			With your consent, we may use usage data to provide personalized
			recommendations. Such profiling data is kept for up to 1 year.
		</Paragraph>

		<Card>
			<Title level={3}>11. Changes to This Policy</Title>
			<Paragraph>
				We may update this Privacy Policy; changes take effect upon
				posting. Significant updates will be communicated via email or
				in-app notice.
			</Paragraph>
		</Card>

		<Title level={3}>12. Acceptance</Title>
		<Paragraph>
			Continued use of our platform constitutes acceptance of this policy.
			For terms of service, see{' '}
			<Link to="terms-and-conditions">Terms & Conditions</Link>.
		</Paragraph>
	</GeneralContentWrapper>
)

export default PrivacyPolicy
